import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppStore } from '../../store/useAppStore'
import { useDocumentSearch } from '../../features/document'
import { Button } from '../ui/Button'
import { Icon } from '../ui/Icon'
import { SearchBox } from './SearchBox'
import { PageList } from './PageList'

/**
 * 侧边栏组件
 * 包含新建文档按钮、搜索框和文档列表
 */
export const Sidebar = React.memo(() => {
  const { t } = useTranslation()
  const { createNewDocument, isSidebarVisible, documents, toggleSidebar } = useAppStore()
  const { search, clearSearch, filteredResults } = useDocumentSearch()
  const [searchQuery, setSearchQuery] = useState('')

  const handleCreateNew = () => {
    createNewDocument()
    if (window.innerWidth < 768) {
      toggleSidebar()
    }
  }

  const handleSearch = async (q: string) => {
    setSearchQuery(q)
    if (q.trim()) await search(q)
    else clearSearch()
  }

  const displayDocs = searchQuery.trim() ? filteredResults : documents

  return (
    <aside 
      className={`
        fixed left-0 top-14 bottom-0 w-64 z-40 flex flex-col
        transition-transform duration-300 ease-in-out
        ${isSidebarVisible ? 'translate-x-0' : '-translate-x-full'}
        ${isSidebarVisible ? 'shadow-2xl md:shadow-none' : ''}
      `}
      style={{
        background: 'var(--bg-primary)',
        borderRight: '1px solid var(--border-light)'
      }}
    >
      {/* 新建文档按钮 */}
      <div 
        className="p-4 flex-shrink-0"
        style={{
          borderBottom: '1px solid var(--border-light)'
        }}
      >
        <Button
          onClick={handleCreateNew}
          variant="primary"
          size="sm"
          className="w-full gap-1"
        >
          <Icon name="plus" size={16} />
          {t('nav.new')}
        </Button>
      </div>

      {/* 搜索框 */}
      <div
        className="p-4 flex-shrink-0"
        style={{
          borderBottom: '1px solid var(--border-light)'
        }}
      >
        <SearchBox value={searchQuery} onChange={handleSearch} />
      </div>

      {/* 文档列表 */}
      <div className="flex-1 overflow-y-auto">
        <PageList documents={displayDocs} />
      </div>
    </aside>
  )
})